import type { Translatable } from "@@/shared/translations/translation";

type SectionGroupItem = {
    _type: "SECTION_GROUP_ITEM";
    type: "SECTION_GROUP" | "SECTION";
    itemId: string;
    title: Translatable;
    sortNumber: number;
};

const sectionGroupItemFactory = (params: {
    type: "SECTION_GROUP" | "SECTION";
    itemId: string;
    title: Translatable;
    sortNumber?: number | null;
}): SectionGroupItem => ({
    _type: "SECTION_GROUP_ITEM",
    type: params.type,
    itemId: params.itemId,
    title: params.title,
    sortNumber: params.sortNumber ?? 0,
});
export { sectionGroupItemFactory };
export type { SectionGroupItem };
